import { useState, useEffect } from "react";
import SubstitutionIcon from '../images/icons/substitution.png';

export default function TeamMissingPlayers ({ playersData, matchId }) {

    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [missingPlayers, setMissingPlayers] = useState([]);

    const DATA_URL = `https://46.ds.lsapp.eu/pq_graphql?_hash=dmpe2&eventId=${matchId}&projectId=46`;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(DATA_URL);
                if (!response.ok) {
                    throw new Error(`Error fetching missing players data: ${response.status} ${response.statusText}`);
                }
                const data = await response.json();
                setData(data);
            } catch (error) {
                console.error('Ошибка загрузки данных о не сыграющих игроках:', error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, [matchId, playersData]);

    useEffect(() => {
        if (!data) return;
        const getMissingPlayers = (teamNumber) => {
            if (!data) return;
            const messingPlayers = [];
            data.data.findEventById.eventParticipants[teamNumber]?.lineup?.missingPlayers?.forEach(player => {
                const reason = player.reason;
                const name = player.player.listName;
                const teamIconPath = `https://static.flashscore.com/res/image/data/${player.player.teamLogo[0].path}`;
                messingPlayers.push({
                    name,
                    reason,
                    teamIconPath,
                });
            });
            return messingPlayers;
        }
        try {
            const teamAMissingPlayers = getMissingPlayers(0);
            const teamBMissingPlayers = getMissingPlayers(1);
            setMissingPlayers({
                "teamA": teamAMissingPlayers,
                "teamB": teamBMissingPlayers,
            });
        } catch (error) {
            console.error('Ошибка обработки данных о не сыграющих игроках:', error);
        }

    }, [data]);

    if (!data) return;
    if (isLoading) return;
    if (!missingPlayers) return;
    if (!missingPlayers.teamA?.length && !missingPlayers.teamB?.length) return;

    const rows = [];
    for (let i = 0; i < Math.max(missingPlayers.teamA.length, missingPlayers.teamB.length); i++) {
        
        const playerA = missingPlayers.teamA[i];
        const playerB = missingPlayers.teamB[i];

        rows.push((
            <div className="table__row">
                {playerA ? (
                    <div className="table__col table__col--grow">
                        <MissingPlayer 
                            name={playerA.name} 
                            reason={playerA.reason} 
                            teamIconPath={playerA.teamIconPath} 
                        />
                    </div>
                ) : (<div className="table__col table__col--grow"></div>)}
                {playerB ? (
                    <div className="table__col table__col--grow">
                        <MissingPlayer 
                            name={playerB.name} 
                            reason={playerB.reason} 
                            teamIconPath={playerB.teamIconPath} 
                            reversed
                        />
                    </div>
                ) : (<div className="table__col table__col--grow"></div>)}
            </div>
        ));
    }

    return (
        <div className="team-substitutions">
            <div className="table">
                <div className="table__row table__header">
                    <div className="table__col">
                        Не сыграют
                    </div>
                </div>
                { rows }
            </div>
        </div>
    );
}

function MissingPlayer ({ name, reason, teamIconPath, reversed }) {
    return (
        <div className={`team-missing-players__player ${reversed ? 'team-missing-players__player--reversed' : ''}`}>
            <div style={{
                display: 'flex', 
                alignItems: 'center',
                gap: '5px'
            }}>
                <img src={teamIconPath} alt="" />
                <span className="team-missing-players__player-name">{name}</span>
            </div>
            <span className="team-missing-players__player-reason">{reason}</span>
        </div>
    )
}